export function distinctOn<T>(arr: T[], on: (t: T) => any) {
  const values = arr.map(a => on(a));
  return arr.filter((v, i) => values.indexOf(on(v)) === i);
}
